import { createContext, useContext } from 'react';

export const SystemNotificationsContext = createContext();
export const useSystemNotificationsContext = () => useContext(SystemNotificationsContext);
